module.exports = __webpack_public_path__ + "img/CS-Hybrid_Overview-GB_1.6efb7dc4.jpg";